import React, { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import SEO from './components/SEO';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import LiveStats from './components/LiveStats';
import Services from './components/Services';
import TechExpertise from './components/TechExpertise';
import Products from './components/Products';
import Process from './components/Process';
import Cloud from './components/Cloud';
import Internship from './components/Internship';
import BlogPreview from './components/BlogPreview';
import CompareTable from './components/CompareTable';
import News from './components/News';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Chatbot from './components/Chatbot';
import WhatsAppFloat from './components/WhatsAppFloat';
import { ScrollProgress, BackToTop } from './components/ScrollProgress';
import CookieBanner from './components/CookieBanner';
import LeadCapture from './components/LeadCapture';
import ProjectCalculator from './components/ProjectCalculator';
import TechStackBadge from './components/TechStackBadge';

export default function App() {
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add('on'); }),
      { threshold: 0.07 }
    );
    document.querySelectorAll('.rv, .rl, .rr, .rs').forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <HelmetProvider>
      <SEO />
      <ScrollProgress />
      <Navbar />

      <main id="main-content">
        <Hero />
        <LiveStats />
        <Services />
        <TechExpertise />
        <Products />
        <Process />
        <Cloud />
        <Internship />
        <BlogPreview />
        <CompareTable />
        <News />
        <Contact />
      </main>

      <Footer />

      <WhatsAppFloat />
      <Chatbot />
      <BackToTop />
      <CookieBanner />
      <LeadCapture />
      <ProjectCalculator />
      <TechStackBadge />
    </HelmetProvider>
  );
}
